var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page"},[(_vm.device === 'desktop')?_c('full-page',{ref:"fullpage",attrs:{"options":_vm.options,"id":"fullpage"}},[_c('Block0'),_c('Block1'),_c('Block2')],1):_c('div',[_c('Block0'),_c('Block1'),_c('Block2')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }